<template>
  <el-dialog
    title="權限管理"
    :visible="isDialogVisible"
    class="editPrivateChargingAuthorizedDialog"
    width="50%"
    :close-on-click-modal="false"
    @open="dialogOpen"
    @close="dialogClose"
  >
    <template #title>
      <div>
        <div style="font-size: 20px;">
          {{ $t("EvCharging.PrivateChargingAuthorized.Title") }}
        </div>
        <div style="font-size: 16px; margin-top: 10px; color: gray;">
          {{ $t("EvCharging.PrivateChargingAuthorized.Description1") }}
        </div>
      </div>
    </template>
    <ul>
      <li>{{ $t("EvCharging.PrivateChargingAuthorized.Description2") }}</li>
      <li>{{ $t("EvCharging.PrivateChargingAuthorized.Description3") }}</li>
    </ul>
    <div class="household-filter">
      <el-select
        v-model="chosenTower"
        class="household-select"
        :placeholder="$t('EvCharging.PrivateChargingAuthorized.SelectBuilding')"
      >
        <el-option
          v-for="tower in towerData"
          :key="tower.Tag"
          :label="tower.Tag"
          :value="tower.Tag"
        />
      </el-select>
      <el-select
        v-model="chosenFloor"
        class="household-select"
        :placeholder="$t('EvCharging.PrivateChargingAuthorized.SelectFloor')"
        :disabled="!chosenTower"
      >
        <el-option
          v-for="floor in floorData"
          :key="floor.Floor"
          :label="$t('EvCharging.PrivateChargingAuthorized.FloorDisplay', { floor: floor.Floor })"
          :value="floor.Floor"
        />
      </el-select>
      <el-select
        v-model="chosenHousehold"
        class="household-select"
        multiple
        collapse-tags
        :placeholder="$t('EvCharging.PrivateChargingAuthorized.SelectHousehold')"
        :disabled="!chosenFloor"
      >
        <el-option
          :label="$t('EvCharging.PrivateChargingAuthorized.SelectAll')"
          :value="'all'"
          :disabled="isDisabledAllTabletOption"
        />
        <el-option
          v-for="tablet in tabletData"
          :key="tablet.TabletId"
          :label="tablet.TabletNote"
          :value="tablet.TabletId"
          :disabled="isDisabledAuthorizedSelect(tablet.TabletId) || chosenHousehold.includes('all')"
        />
      </el-select>
      <el-button
        :disabled="!chosenHousehold.length"
        icon="icon-plus"
        round
        @click="addHousehold"
      >
        {{ $t('EvCharging.PrivateChargingAuthorized.Add') }}
      </el-button>
    </div>
    <div class="household-tags-content">
      <template v-if="!authorizedHousehold.length">
        <div class="no-household-content">
          <div>
            {{ $t("EvCharging.PrivateChargingAuthorized.NoHouseholdSelected") }}
          </div>
        </div>
      </template>
      <template v-else>
        <el-tag
          v-for="household in authorizedHousehold"
          :key="household.TabletId"
          closable
          :disable-transitions="true"
          @close="deleteHousehold(household)"
        >
          {{ household.TabletNote }}
        </el-tag>
      </template>
    </div>
    <span slot="footer">
      <el-button
        type="danger"
        round
        @click="clearAuthorizedDialog"
      >{{ $t("General.ClearAll") }}</el-button>
      <el-button
        round
        @click="dialogClose"
      >{{ $t("General.Cancel") }}</el-button>
      <el-button
        type="primary"
        round
        @click="putAuthorizedTablets"
      >{{ $t("General.Store") }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { apiEvCharging } from '@/api/EvCharging'
export default {
  data () {
    return {
      isDialogVisible: false,
      towerData: [],
      floorData: [],
      tabletData: [],
      chosenTower: '',
      chosenFloor: '',
      chosenHousehold: [], // 目前在select選單上的戶別
      authorizedHousehold: [], // 已被加進列表中的戶別
      originAuthorizedHousehold: [] // 存一份初始資料，離開時才知道資料是否被更改
    }
  },
  computed: {
    isDisabledAllTabletOption () {
      const isDisabled = this.tabletData.every((item) => {
        const isChosen = this.authorizedHousehold.find((x) => x.TabletId === item.TabletId)
        return isChosen
      })
      return isDisabled
    }
  },
  watch: {
    '$store.state.evCharging.isOpenPrivateChargingAuthorizedDialog': {
      handler: function (newVal, oldVal) {
        // 外部可以開啟dialog，但關閉僅由內部控制
        if (newVal) { this.isDialogVisible = newVal }
      }
    },
    chosenTower: {
      handler: async function () {
        if (this.chosenTower !== '') {
          await this.getFloors()
          this.chosenFloor = ''
          this.chosenHousehold = []
        }
      }
    },
    chosenFloor: {
      handler: async function () {
        if (this.chosenFloor !== '') {
          await this.getTablets()
          this.chosenHousehold = []
        }
      }
    },
    chosenHousehold: {
      handler: function (n, o) {
        if ((!o.includes('all') && n.includes('all')) || (this.chosenHousehold.length === this.tabletData.length && this.chosenHousehold.length > 0 && !this.chosenHousehold.includes('all'))) {
          this.chosenHousehold = ['all']
        }
      }
    }

  },
  methods: {
    dialogOpen () {
      this.getTags()
      this.getConnectorAllowListTablets()
    },
    async getTags () {
      try {
        const res = await apiEvCharging.Community.GetTags()
        this.towerData = res.data.Data.Tags
      } catch (err) {
        console.log(err)
      }
    },
    async getFloors () {
      try {
        const res = await apiEvCharging.Community.GetFloors(this.chosenTower)
        this.floorData = res.data.Data.Floors
      } catch (err) {
        console.log(err)
      }
    },
    async getTablets () {
      try {
        const res = await apiEvCharging.Community.GetTablets(this.chosenTower, this.chosenFloor)
        this.tabletData = res.data.Data.Tablets
      } catch (err) {
        console.log(err)
      }
    },
    // 新增使用私有樁戶別
    addHousehold () {
      if (this.chosenHousehold.includes('all')) {
        this.tabletData.forEach((item) => {
          const isChosen = this.authorizedHousehold.find((x) => x.TabletId === item.TabletId)
          if (!isChosen) {
            this.authorizedHousehold.push(item)
          }
        })
      } else {
        this.chosenHousehold.forEach((item) => {
          const household = this.tabletData.find((x) => x.TabletId === item)
          const isChosen = this.authorizedHousehold.find((x) => x.TabletId === item)

          if (household && !isChosen) { this.authorizedHousehold.push(household) }
        })
      }
      this.chosenTower = ''
      this.chosenFloor = ''
      this.chosenHousehold = []
    },
    // 刪除私有樁戶別其中一戶
    deleteHousehold (household) {
      const index = this.authorizedHousehold.findIndex((x) => x.TabletId === household.TabletId)
      if (index > -1) this.authorizedHousehold.splice(index, 1)
    },
    // select選單禁止掉已有選項
    isDisabledAuthorizedSelect (id) {
      return !!this.authorizedHousehold.find((el) => el.TabletId === id)
    },
    clearAuthorizedDialog () {
      this.chosenTower = ''
      this.chosenFloor = ''
      this.tabletData = []
      this.floorData = []
      this.chosenHousehold = []
      this.authorizedHousehold = []
    },
    // 取得私有樁戶別
    async getConnectorAllowListTablets () {
      try {
        const ConnectorSn = this.$store.state.evCharging.privateChargingConnectorSn
        const res = await apiEvCharging.Management.getConnectorAllowList(ConnectorSn)
        this.authorizedHousehold = res.data.Data.Tablets

        this.originAuthorizedHousehold = _cloneDeep(this.authorizedHousehold)
      } catch (err) {
        console.log(err)
      }
    },
    // 設定授權戶
    async putAuthorizedTablets () {
      const authorizedToCompare = this.authorizedHousehold.map(item => ({
        TabletId: item.TabletId,
        TabletNote: item.TabletNote
      }))
      const originAuthorizedHouseholdToCompare = this.originAuthorizedHousehold.map(item => ({
        TabletId: item.TabletId,
        TabletNote: item.TabletNote
      }))
      if (_isEqual(originAuthorizedHouseholdToCompare, authorizedToCompare)) {
        // 資料沒變就不打api，減少api壓力
        this.$message({
          message: this.$t('EvCharging.PrivateChargingAuthorized.HouseholdUpdated'),
          type: 'success'
        })
        return
      }

      try {
        const ConnectorSn = this.$store.state.evCharging.privateChargingConnectorSn
        const tabletIds = this.authorizedHousehold.map(item => item.TabletId)
        await apiEvCharging.Management.putConnectorsAllowList(ConnectorSn, tabletIds)
        this.$message({
          message: this.$t('EvCharging.PrivateChargingAuthorized.HouseholdUpdated'),
          type: 'success'
        })
        this.originAuthorizedHousehold = _cloneDeep(this.authorizedHousehold)
      } catch (e) {
        console.log(e)
      }
    },
    dialogClose () {
      // 理論上可用:before-close實作此需求，但before-close不知為何一直被不預期的呼叫
      // 因此採用@close實作此需求，透過手動控制isDialogVisible去控開關
      this.isDialogVisible = true
      this.chosenTower = ''
      this.chosenFloor = ''
      this.chosenHousehold = []
      const authorizedToCompare = this.authorizedHousehold.map(item => ({
        TabletId: item.TabletId,
        TabletNote: item.TabletNote
      }))
      const originAuthorizedHouseholdToCompare = this.originAuthorizedHousehold.map(item => ({
        TabletId: item.TabletId,
        TabletNote: item.TabletNote
      }))
      if (_isEqual(originAuthorizedHouseholdToCompare, authorizedToCompare)) {
        this.$store.commit('triggerPrivateChargingAuthorizedDialog', false)
        this.isDialogVisible = false
        return
      }

      this.$confirm(this.$t('EvCharging.PrivateChargingAuthorized.LeaveWithoutSavingWarning'), this.$t('EvCharging.PrivateChargingAuthorized.NotSaved'), {
        confirmButtonText: this.$t('EvCharging.PrivateChargingAuthorized.Leave'),
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: this.$t('General.Cancel'),
        closeOnClickModal: false
      }).then(action => {
        this.$store.commit('triggerPrivateChargingAuthorizedDialog', false)
        this.isDialogVisible = false
        this.authorizedHousehold = _cloneDeep(this.originAuthorizedHousehold)
      }).catch(() => {})
    }
  }
}
</script>
  <style lang="scss" scoped>
    .editPrivateChargingAuthorizedDialog {
      ::v-deep .el-dialog {
        @include basicDialog;
        ul {
          margin-bottom: 20px;
          text-align: left;
          list-style-position: inside;
          li {
            margin-top: 10px;
            list-style-type: disc;
            margin-left: 20px;
          }
        }
        p {
          margin-top: 2rem;
          margin-bottom: 0.5rem;
        }
        .household-filter {
          display: flex;
        }
        .household-select {
          padding-right: 5px;
        }
        .household-tags-content {
          padding: 20px 0;
          min-height: 200px;
          max-height: 35vh;
          overflow-y: auto;
          text-align: left; // 確保內部內容靠左對齊
          .el-tag {
            margin-right: 3px;
            margin-top: 3px;
            display: inline-block; // 保證 tag 是 inline-block，確保能多行排列
          }
        }

        .no-household-content {
          padding-block: 20px;
          text-align: center; // 保持 "未選擇任何戶別" 置中
          font-weight: bold;
        }
        .el-dialog__footer {
          text-align: center
        }

      }
    }
    .mainColor-text {
      color: $mainColor;
    }
    .dangerColor-text {
      color: $dangerColor;
    }
  </style>
